<script
    src="../../../../../../../Library/Containers/com.tencent.xinWeChat/Data/Library/Application Support/com.tencent.xinWeChat/2.0b4.0.9/fe0c632c4e309027cdc117e76ea3adaf/Message/MessageTemp/c503fbdb29b0f97cea5714d271ccd4f3/File/vite.config.js"></script>
<template>
  <div class="modal" :class="customClassName" id="loginModal" role="dialog">
    <div
      class="modal-bg"
      @click="onModalClose"
      v-show="!customClass || customClass == ''"
    ></div>
    <div class="modal-dialog" style="top: 0px">
      <div class="login modal-body">
        <div class="form form--login">
          <div class="form--login__top"></div>
          <div
            class="form--login__tips login-code-content"
            v-show="mode == 0 || isHideQrCode"
          >
            <img
              src="https://resource.rcclchina.com.cn/login/switch-phone.png"
            />
          </div>
          <div
            class="form--login__tips login-phone-content"
            v-show="mode == 1 && !isHideQrCode"
          >
            <img
              src="https://resource.rcclchina.com.cn/login/switch-code.png"
            />
          </div>
          <div class="form--login-bg">
            <img
              src="https://resource.rcclchina.com.cn/login/loginModal_BG.png"
            />
          </div>

          <div
            class="form--login__tips login-code-content"
            v-show="mode == 0 && !isHideQrCode"
            @click="mode = 1"
          >
            <div class="form--login__wrapper" id="loginCodeContentWrapper">
              <div
                class="form--login__tips_tooltip login-code-content"
                id="loginChangeCode"
              ></div>
              <b-tooltip
                :container="'loginCodeContentWrapper'"
                :target="'loginChangeCode'"
                triggers="hover"
                placement="left"
              >
                手机登录/注册
              </b-tooltip>
            </div>
          </div>
          <div
            class="form--login__tips login-phone-content"
            v-show="mode == 1 && !isHideQrCode"
            @click="mode = 0"
          >
            <div class="form--login__wrapper" id="loginPhoneContentWrapper">
              <div
                class="form--login__tips_tooltip"
                id="loginChangePhone"
              ></div>
              <b-tooltip
                :container="'loginPhoneContentWrapper'"
                :target="'loginChangePhone'"
                triggers="hover"
                placement="left"
              >
                微信扫码登录
              </b-tooltip>
            </div>
          </div>

          <div
            class="form--login__right wechat-login-wrapper login-code-content"
            v-show="mode == 0"
          >
            <div class="form--login__title">
              <div class="form--login__title-image">
                <img src="https://resource.rcclchina.com.cn/logo/PC/logoAnchorBlue.png" />
              </div>
              <div class="form--login__title-text">微信扫码登录</div>
            </div>
            <div class="tab--content form--login__content">
              <div class="rccl--form">
                <img
                  class="codeLogin"
                  :src="qrCode.url"
                  v-if="qrCode.url.length > 0"
                />
                <p>请使用微信扫码登录</p>
              </div>
            </div>
          </div>
          <div
            class="form--login__right phone-login-wrapper login-phone-content"
            v-show="mode == 1"
          >
            <div class="form--login__title">
              <div class="form--login__title-image">
                <img src="https://resource.rcclchina.com.cn/logo/PC/logoAnchorBlue.png" />
              </div>
              <div class="form--login__title-text">手机号登录/注册</div>
            </div>
            <div
              class="tab--content form--login__content mobile_login phone_login"
            >
              <div class="rccl--form">
                <div class="input input--login--mobile">
                  <div class="row new-gutter">
                    <div class="col-md-4 col-xs-4 callingCode-content">
                      <div class="dropdown callingCode" data-value="+86">
                        <button
                          class="btn btn-default dropdown-toggle"
                          type="button"
                          id="callingCodeDropDown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="true"
                        >
                          <span class="callingcode-name">{{
                            `${selectedCallingCode.countryName}(${selectedCallingCode.callingCode})`
                          }}</span>
                          <span class="caret"></span>
                        </button>
                        <ul
                          class="dropdown-menu callingcode-dropdown"
                          aria-labelledby="callingCodeDropDown"
                        >
                          <li
                            v-for="(code, i) in callingCodes"
                            :key="'callingCode_' + i"
                          >
                            <a @click="onCallingCodeChange(code.callingCode)">{{
                              `${code.countryName}(${code.callingCode})`
                            }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      class="col-md-8 col-xs-8 phone-input-content"
                      style="padding-left: 23px"
                    >
                      <input
                        name="Telephone"
                        v-model="mobile"
                        placeholder="手机号"
                        type="text"
                        class="form-control"
                        style="width: 249px"
                        required="required"
                        @change="onMobileChange($event)"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="input input--login--mobile picVerifyCode">
                                    <div class="row new-gutter">
                                        <div class="col-md-8 col-xs-8 veriCode-content">
                                            <input v-model="picCode"
                                                class="picCode form-control input--veriCode" placeholder="图形验证码" type="text" name="input_loginCode" id="">
                                        </div>
                                        <div class="col-md-4 col-xs-4 phone-input-content picCode-content">
                                            <img id="codeLogin" class="i1_pic " title="" :src="picCodeImage">
                                            <a class="changeCode" @click="getPicCode">换一换</a>
                                        </div>
                                    </div>
                                </div> -->
                <div class="input input--login--mobile">
                  <div class="row new-gutter">
                    <div class="col-md-8 col-xs-8 veriCode-content">
                      <input
                        name="VerifyCode"
                        v-model="smsCode"
                        placeholder="验证码"
                        type="text"
                        class="input--veriCode form-control"
                      />
                    </div>

                    <div class="col-md-4 col-xs-4 phone-input-content">
                      <button
                        class="get_code"
                        type="button"
                        id="sendCode"
                        @click="onSmsClick"
                        v-show="smsCodeCountDown <= 0"
                        :class="{ disabled: smsCodeCountDown > 0 }"
                      >
                        {{ getSendSmsCodeText() }}
                      </button>
                      <button
                        class="get_code"
                        type="button"
                        v-if="smsCodeCountDown > 0"
                        :class="{ disabled: smsCodeCountDown > 0 }"
                      >
                        {{ getSendSmsCodeText() }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="input input--login--mobile">
                  <div v-show="showMarketingFlagEmail" class="row new-gutter">
                    <div class="col-md-8 veriCode-content">
                      <input
                          name="RecommendedCode"
                          v-model="marketingEmailInput"
                          placeholder="邮箱（建议）"
                          type="text"
                          style="width: 386px"
                          class="input--veriCode form-control recommendedCode-js"
                      />
                    </div>
                  </div>
                  <div v-show="!isRegisteredReward" class="row new-gutter" style="margin-top: 15px">
                    <div class="col-md-8 veriCode-content">
                      <input
                        name="RecommendedCode"
                        v-model="recommendedCode"
                        placeholder="好友推荐码（选填）"
                        type="text"
                        style="width: 386px"
                        class="input--veriCode form-control recommendedCode-js"
                      />
                    </div>
                  </div>
                </div>
                <div class="button">
                  <button
                    id="form-login-submit-button-telephone"
                    class="form--login__button"
                    type="button"
                    @click="onLoginClick"
                  >
                    立即登录/注册
                  </button>
                </div>
                <div v-if="!isTrade" class="sin_container">
                  <div class="input__top isAgreePrivacy"
                       v-show="!isRegistered && isShowReward"
                       :class="{ active: isCheckAll }"
                       @click="handleCheckAll">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>全选</span>
                  </div>
                  <div class="login-vip mt15"
                       v-show="isRegistered && !isRegisteredReward && isShowReward">
                    <div class="vip-title">加入会员尊享</div>
                    <ul class="vip-content">
                      <li>获得积分兑换精美礼品</li>
                      <li>提前获取订票优惠及品牌资讯</li>
                      <li>尊享更多会员线上线下活动通知</li>
                    </ul>
                  </div>
                  <div class="input__top isRegisterMember"
                       v-show="(!isRegistered || !isRegisteredReward) && isShowReward"
                       :class="{ active: wantToRegisterReward }"
                       @click="handleCheckItem('wantToRegisterReward')">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>我同意注册“皇家游享荟”会员（限中国大陆地区手机号），并接收品牌资讯及优惠信息，详见<a :href="rewardPrivacyLink" target="_blank" class="privacyLink external">《项目细则》</a></span>
                  </div>
                  <div
                      class="input__top isAgreePrivacy"
                      v-show="!isRegistered"
                      @click="handleCheckItem('wantToAgreePrivacy')"
                      :class="{ active: wantToAgreePrivacy }">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>我已阅读并同意<a :href="privacyLink" target="_blank" class="privacyLink external">《隐私政策》</a><a :href="userAgreementLink" target="_blank" class="privacyLink external">《用户协议》</a></span>
                  </div>
                  <div
                      class="input__top isAgreePrivacy"
                      v-show="isRegisteredReward && !isAgreeEmail && isShowReward"
                      :class="{ active: wantToAgreeEmail }"
                      @click="handleCheckItem('wantToAgreeEmail')">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>我想提前获取优惠信息，且同意接收皇家加勒比国际游轮品牌资讯</span>
                  </div>
<!--                  <div class="input__top isRegisterMember"-->
<!--                    v-show="!isRegisteredReward && isShowReward"-->
<!--                    :class="{ active: wantToRegisterReward }"-->
<!--                    @click="handleCheckItem('wantToRegisterReward')"-->
<!--                  >-->
<!--                    <img-->
<!--                      src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"-->
<!--                    />-->
<!--                    <img-->
<!--                      src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"-->
<!--                    />-->
<!--                    <span-->
<!--                      >我已阅读<a-->
<!--                        :href="rewardPrivacyLink"-->
<!--                        target="_blank"-->
<!--                        class="privacyLink external"-->
<!--                        >《“皇家游享荟”项目细则》</a-->
<!--                      >并同意注册“皇家游享荟”会员及接受会员相关的优惠资讯及推送消息</span>-->
<!--                  </div>-->
<!--                  <div-->
<!--                    class="input__top isAgreePushMsg"-->
<!--                    :class="{ active: wantToAgreeEmail }"-->
<!--                    v-show="!isAgreeEmail && !isRegisteredReward && (isShowReward || isShowHongKong)"-->
<!--                    @click="handleCheckItem('wantToAgreeEmail')"-->
<!--                  >-->
<!--                    <img-->
<!--                      src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"-->
<!--                    />-->
<!--                    <img-->
<!--                      src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"-->
<!--                    />-->
<!--                    <span-->
<!--                      >我同意接收皇家加勒比游轮船务（中国）有限公司及其关联公司的优惠资讯及推送信息。</span>-->
<!--                  </div>-->
                </div>
                <!--旅行社Trade-->
                <div v-else class="sin_container">
                  <div class="input__top isAgreePrivacy"
                       v-show="!isRegistered && !isAgreeEmail"
                       :class="{ active: isCheckAll }"
                       @click="handleCheckAllTrade">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>全选</span>
                  </div>
                  <div
                      class="input__top isAgreePrivacy"
                      v-show="!isAgreeEmail"
                      :class="{ active: wantToAgreeEmail }"
                      @click="handleCheckItem('wantToAgreeEmail')">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>我同意获取皇家加勒比游轮船务(中国)有限公司及其关联公司的优惠资讯。</span>
                  </div>
                  <div
                      class="input__top isAgreePrivacy"
                      v-show="!isRegistered"
                      @click="handleCheckItem('wantToAgreePrivacy')"
                      :class="{ active: wantToAgreePrivacy }">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>我已阅读并同意<a :href="privacyLink" target="_blank" class="privacyLink external">《隐私政策》</a><a :href="userAgreementLink" target="_blank" class="privacyLink external">《用户协议》</a></span>
                  </div>
                </div>
                <div class="sin_container">
                  <div
                      class="input__top isAgreePrivacy"
                      v-show="showMarketingFlagEmail"
                      :class="{ active: marketingFlagEmail }"
                      @click="handleCheckItem('marketingFlagEmail')">
                    <img src="https://resource.rcclchina.com.cn/bookingPay/icon-checkBox-checked-4.jpg"/>
                    <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg"/>
                    <span>我同意<em class="is-important">电子邮箱</em>接受皇家加勒比品牌资讯及优惠信息</span>
                  </div>
                </div>
                <div class="loginPromot infinite-scroll help-block" style="margin-top: 5px">
                  如之前未用该手机注册过，则会自动为您创建新用户账号，方便您之后直接登录。
                </div>
                <div>
                  <input type="hidden" name="LoginType" value="5" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="captchaElement"></div>
    <button id="captchaTrigger" type="button" style="display:none"></button>
  </div>
</template>

<script>
import api from "@/api";
import Cookies from "js-cookie";
import { gioTracking, isEmpty } from "@/utilities/tools";
const SCENE_ID = 'tqbrb5ax';
export default {
  name: "LoginModal",
  props: {
    customClass: {
      type: String,
    },
    isShow: {
      type: Boolean,
    },
    isHideQrCode: {
      type: Boolean,
      default: false,
    },
    onLoginSuccessHandler: {
      type: Function,
    },
    redirectUri: {
      type: String,
      default () {
        return ""
      }
    }
  },
  data() {
    return {
      isShowModal: false,
      mode: 0,
      callingCodes: [],
      isRegistered: true,
      isRegisteredReward: true,
      isAgreeEmail: true,
      isShowReward: true,
      selectedCallingCode: {
        callingCode: "+86",
        countryName: "中国",
      },
      mobile: "",
      smsCode: "",
      smsCodeCountDown: 0,
      recommendedCode: "",
      wantToRegisterReward: false,
      wantToAgreeEmail: false,
      wantToAgreePrivacy: false,
      qrCode: {
        token: "",
        url: "",
      },
      checkQrCodeLoginTimeout: null,
      isAllowLogin: true,
      afsType: "AliYunAfsNvc",
      isCheckAll: false,
      isTrade: false,
      loading: false,
      captcha: null,
      showMarketingFlagEmail: false,
      marketingFlagEmail: false,
      originalMarketingFlagEmail: false,
      marketingEmailInput: "",
      captchaVerifyParamLogin:'',
      captchaBizType: null  // 当前业务验证类型：login | sms
    };
  },
  async beforeMount() {
    if(this.$route.query?.viewSource) {
      this.isTrade = this.$route.query?.viewSource === 'pcpTrade';
      this.$store.dispatch("SET_VIEW_SOURCE", this.$route.query.viewSource);
    } else {
      this.isTrade = this.viewSource && this.viewSource === 'pcpTrade';
    }
    const { success, data, errMsg } = await api.page.getCallingCode();
    if (!success) console.error(errMsg);
    this.callingCodes = data;

    if (this.isHideQrCode) {
      this.mode = 1;
    } else if (this.isShow) {
      this.getQrCode();
    }
  },
  mounted() {
    this.initCaptcha();
  },
  beforeDestroy() {
    if (this.checkQrCodeLoginTimeout) {
      clearTimeout(this.checkQrCodeLoginTimeout);
    }
  },
  methods: {
		onCallingCodeChange(value) {
      const callingCode = this.callingCodes.filter(
        (r) => r.callingCode == value
      );
      if (callingCode && callingCode.length > 0) {
        this.selectedCallingCode = callingCode[0];
      }
      this.isShowReward = (value === "+86" || value === "86") || (value === "+852" || value === "852") || (value === "+853" || value === "853")
      this.wantToRegisterReward = this.wantToAgreeEmail = this.wantToAgreePrivacy = this.isCheckAll = false;
      this.checkIsRegister(this.mobile)
      // this.isShowHongKong = (value === "+852" || value === "852") || (value === "+853" || value === "853")
    },
    onMobileChange(e) {
      const mobile = e.target.value;
      this.mobile = mobile;
      this.checkIsRegister(mobile);
    },
    async checkIsRegister(mobile) {
      if (mobile == null || mobile.length == 0) return
      const { success, data, errMsg } = await api.user.checkHasRegister(
        mobile,
        this.selectedCallingCode.callingCode
      );
      if (!success) console.error(errMsg);
      this.isRegistered = data.hasRegisterUser;
      this.isRegisteredReward = data.hasRegisterReward;
      // this.isAgreeEmail = data.hasAgreeEmail;
      this.isAgreeEmail = data.receiveMarketingFlag;
      this.originalMarketingFlagEmail = data.marketingFlagEmail;
      this.showMarketingFlagEmail = !data.marketingFlagEmail;
    },
    // 验证码初始化
    initCaptcha () {
			if (!window.initAliyunCaptcha) return
      window.initAliyunCaptcha({
        SceneId: SCENE_ID,
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: "popup",
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: "#captchaElement",
        // 触发验证码弹窗或无痕验证的元素
        button: '#captchaTrigger',
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
        slideStyle: {
          width: 360,
          height: 40,
        },
        // 验证码验证通过回调函数
        success: this.onCaptchaSuccess,
        // 验证码验证不通过回调函数
        fail: this.captchaFail,
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: (instance) => {
          this.captcha = instance
        }
      });
		},
    onCaptchaSuccess(captchaRes) {
      const biz = this.captchaBizType
      // 刷新
      this.captcha && this.captcha.refresh();
      
      this.$loading.hide();
      if (biz === 'login') {
        this.captchaSuccessLogin(captchaRes)
      } else if (biz === 'sms') {
        this.captchaSuccessSms(captchaRes)
      }
    },
    captchaFail(error) {
      this.loading = false
      this.captchaBizType = null
      this.isAllowLogin = false
    },
    async captchaSuccessSms(captchaVerifyParam) {
      try {
        this.isAllowLogin = true;
        this.$loading.show();
        const request = this.getSmsRequest("AliYunAfsNc", captchaVerifyParam);
        await this.sendSmsApi(request);
      } finally {
        this.resetCaptcha()
      }
    },
    async captchaSuccessLogin(captchaVerifyParam) {
      try {
        this.isAllowLogin = true;
        this.captchaVerifyParamLogin = captchaVerifyParam
        await this.login();
      } finally {
        this.resetCaptcha()
      }
    },
    // 点击登录
    onLoginClick() {
      /* 先进行验证，再访问接口 */
      if (!this.isRegistered && !this.wantToAgreePrivacy) {
        this.$alert.show("请勾选隐私政策");
        return;
      }

      if (this.mobile == null || this.mobile.length == 0) {
        this.$alert.show("请输入手机号");
        return;
      } else if (this.smsCode == "") {
        this.$alert.show("请输入短信验证码");
        return;
      }
      if(this.originalMarketingFlagEmail === false) {
        if(this.marketingFlagEmail) {
          if(isEmpty(this.marketingEmailInput)) {
            this.$alert.show("请输入您的邮箱");
            return;
          } else {
            const emailRx = /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/;
            console.log('emailRx.test(marketingEmailInput)', emailRx.test(this.marketingEmailInput))
            if(!emailRx.test(this.marketingEmailInput)) {
              this.$alert.show("请输入正确的邮箱");
              return;
            }
          }
        } else {
          if(!isEmpty(this.marketingEmailInput)) {
            this.$alert.show("请勾选同意电子邮箱<br/>接受皇家加勒比品牌资讯及优惠信息");
            return;
          }
        }
      }

      if (this.loading) return;
      this.captchaBizType = 'login'
      this.loading = true
      document.getElementById('captchaTrigger').click()
    },
    onSmsClick() {
      if (this.loading) return
      this.captchaBizType = 'sms'
      this.loading = true
      document.getElementById('captchaTrigger').click()
    },
    resetCaptcha() {
      if (this.captcha && typeof this.captcha.refresh === 'function') {
        this.captcha.refresh()
      }
      this.captchaBizType = null
      this.loading = false
      this.isAllowLogin = false
    },
		getSmsRequest (codeType, codeValue) {
			let callingCode = this.selectedCallingCode.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }
			const request = {
        phone: this.mobile,
        callingCode: callingCode,
        sessionKey: this.sessionKey,
        isPc:true,
				codeType: codeType,
				codeValue: codeValue,
        sceneId: SCENE_ID,
        captchaVerifyParam:codeValue
      };
			return request;
		},
    async sendSmsApi(request) {
			if (!this.isAllowLogin) return;
      const { success, data, errMsg } = await api.user.smsCodeLogin(request);
      this.$loading.hide();
      if (!success) {
        console.error(errMsg);
				if (errMsg == 'NvcNc' || errMsg == 'Block') {
				} else {
					this.$alert.show(errMsg);
				}
        return;
      } else {
				if (data && data.sessionKey) {
					this.$store.commit("SET_SESSION_KEY", data.sessionKey);
				}
        this.$alert.show(
          "短信发送成功！若您没有收到短信验证，请一分钟后重新发送。"
        );
      }
      this.smsCodeCountDown = 60;
      const self = this;
      let countDown = setInterval(() => {
        if (self.smsCodeCountDown == 0) {
          clearInterval(countDown);
        } else {
          self.smsCodeCountDown--;
        }
      }, 1000);
    },
    async login () {
			if (!this.isAllowLogin) return;
      this.$loading.show();
      let callingCode = this.selectedCallingCode.callingCode;
      if (
        callingCode &&
        callingCode.length > 1 &&
        callingCode.indexOf("+") == 0
      ) {
        callingCode = callingCode.substring(1);
      }

      let isAgreeEmail,isRegisterMember;
      if(!this.isTrade) {
        if(this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
          isAgreeEmail = isRegisterMember = this.wantToAgreeEmail && this.isShowReward;
        } else {
          isAgreeEmail = isRegisterMember = this.wantToRegisterReward && this.isShowReward;
        }
      } else {
        isAgreeEmail = this.wantToAgreeEmail;
        isRegisterMember = false;
      }

      let params = {
        mobile: this.mobile,
        smsCode: this.smsCode,
        callingCode: callingCode,
        sessionKey: this.sessionKey,
        recommendedCode: this.recommendedCode,
        source: "PC",
        isAgreeEmail: isAgreeEmail,
        isRegisterMember: isRegisterMember,
        openId: this.$store.state.user.wechatOpenId,
        isCheckPrivacy: this.wantToAgreePrivacy,
        sceneId: SCENE_ID,
        captchaVerifyParam: this.captchaVerifyParamLogin,
        returnUrl: this.redirectUri || this.$router.currentRoute.query.returnUrl || ''
      }

      // 未接受过邮件
      if(this.originalMarketingFlagEmail === false) {
        params =  Object.assign(params, {
          marketingFlagEmail: this.marketingFlagEmail,
          marketingEmail: this.marketingEmailInput
        })
      }

      const { success, data, errMsg } = await api.user.login(params);
      this.$loading.hide();
      if (!success) {
        console.error(errMsg);
        this.$alert.show(errMsg);
      } else if (data && data.accessToken) {
        // 缓存 isAcceptPersonalRecommend 到 localStorage
        if (data.isAcceptPersonalRecommend !== undefined) {
          localStorage.setItem('isAcceptPersonalRecommend', data.isAcceptPersonalRecommend ? 'true' : 'false')
        } else {
          // 线上已登录用户默认已接受推送
          localStorage.setItem('isAcceptPersonalRecommend', 'true')
        }
        this.$store.dispatch("SET_USER_TOKEN", data.accessToken);
        this.$store.dispatch("GET_USER_INFO", data.accessToken);
        Cookies.remove(".ASPXAUTH", { path: "/" });
        this.loginSuccessHandler(data);
      }
    },
    loginSuccessHandler(response) {
      try {
        let hmsrTxt = this.$store.state.page.trackingCode.hmsr + "";
        if (hmsrTxt == "") {
          hmsrTxt = "不适用";
        }

        let marketable = "";
        const isNewUser = response.isNewUser ? "1" : "0";
        const isNewLocalReward = response.isNewLocalReward ? "1" : "0";
        if (isNewUser == "1") {
          if (isNewLocalReward == "1" || this.wantToAgreeEmail) {
            marketable = "1";
          } else {
            marketable = "2";
          }
        } else if (isNewLocalReward == "1") {
          marketable = "1";
        } else if (isNewLocalReward == "0" && (!this.isRegisteredReward || !this.isShowReward)) {
          marketable = "0";
        } else if (this.isRegisteredReward && this.isShowReward) {
          marketable = "1";
        }

        let eventName = response.isNewUser ? 'evt_Register': 'evt_Login';
        let isAll = 'nil';
        if(this.isCheckAll) {
          isAll = this.isCheckAll ? '1' : '0';
        }
        let isNewLR = 'nil'
        if (response.isNewLocalReward) {
          isNewLR = this.wantToRegisterReward ? '1': '0';
        }
        // let isMkt = "nil";
        // if (!this.isAgreeEmail) {
        //   isMkt = this.wantToAgreeEmail ? "1": "0";
        // }
        let sUrl = "nil"
        if (response.returnUrl && response.returnUrl.length > 0) {
          sUrl = decodeURIComponent(response.returnUrl)
        }
        //isQR, mode 与 gio要提交的数据相反，mode 0 是扫码，gio提交的1是扫码
        gioTracking('track', eventName, {
          // isMkt: isMkt,
          // isNewLR: isNewLR,
          isNewLRMkt: isNewLR,
          isAll: isAll,
          sUrl,
          regUrl: location.href,
          isQR: this.mode == 1 ? 0 : 1
        })
        if (response.cmsId) {
          gioTracking('setUserId', response.cmsId);
        }
        if (response.localRewardId) {
          gioTracking('people.set', response.localRewardId);
        } else {
          gioTracking('people.set', 'nil');
        }

        if (window.gio) {
          window.gio("page.set", "LoginStatus", hmsrTxt + isNewUser);
          window.gio("track", "LoginStatusTracking", {
            LoginStatusTracking: hmsrTxt + isNewUser,
            IsNewLocalReward: hmsrTxt + isNewLocalReward,
            IsMarketable: marketable,
          });
          window.gio("track", "NewLoginTracking", {
            NewLoginTracking: isNewUser,
          });
        }
      } catch (e) {
        console.error(e);
      }

      if (this.onLoginSuccessHandler) {
        this.onLoginSuccessHandler(response);
      }
    },
    getSendSmsCodeText() {
      if (this.smsCodeCountDown <= 0) {
        return "发送验证码";
      } else {
        return `验证码(${this.smsCodeCountDown}s)`;
      }
    },
    onModalClose() {
      this.isShowModal = false;
      setTimeout(() => {
        this.$emit("onModalClose");
      }, 100);
    },
    async getQrCode() {
      const { data } = await api.user.getLoginQrCode();
      if (data && data.token && data.url) {
        this.qrCode = data;
				if (process.env.NODE_ENV == 'production') {
					this.checkQrCodeLoginTimeout = setInterval(() => {
						this.checkQrCodeScanned();
					}, 2000);
				}
      }
    },
    async checkQrCodeScanned() {
      if (
        this.qrCode &&
        this.qrCode.token &&
        this.qrCode.token.length > 0 &&
        this.mode == 0 &&
        !this.isHideQrCode
      ) {
        const { success, data } = await api.user.isQrCodeLogin(
          this.qrCode.token
        );
        if (success && data) {
          if (data.success) {
            if (data.openId && data.openId.length > 0) {
              this.$store.commit("SET_WECHAT_OPENID", data.openId);
            }
            if (data.accessToken && data.accessToken.length > 0) {
              // 缓存 isAcceptPersonalRecommend 到 localStorage
              if (data.isAcceptPersonalRecommend !== undefined) {
                localStorage.setItem('isAcceptPersonalRecommend', data.isAcceptPersonalRecommend ? 'true' : 'false')
              } else {
                // 线上已登录用户默认已接受推送
                localStorage.setItem('isAcceptPersonalRecommend', 'true')
              }
              this.$store.commit("SET_USER_TOKEN", { token: data.accessToken });
              this.loginSuccessHandler({
                isNewUser: false,
                isRegisteredMember: false,
                accessToken: data.accessToken
              });
            } else {
              // this.$router.push({
              //   name: "WechatBind",
              //   query: { returnUrl: this.returnUrl },
              // });
              let returnUrl = this.redirectUri;
              if (!returnUrl || returnUrl.length === 0) {
                returnUrl = this.returnUrl
              }
              console.log('returnUrl: ' + returnUrl)
              window.location.href = `/Orchard.Rccl.Users/WeChatBanding/WeChatChoose?returnUrl=${encodeURIComponent(returnUrl)}`
            }
          }
        }
      }
    },
    // 全选
    handleCheckAll() {
      if(this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
        this.wantToAgreePrivacy = this.wantToAgreeEmail = this.marketingFlagEmail = this.isCheckAll =! this.isCheckAll;
      } else {
        this.wantToAgreePrivacy = this.wantToRegisterReward = this.marketingFlagEmail = this.isCheckAll =! this.isCheckAll;
      }
    },
    // 全选-旅行社
    handleCheckAllTrade() {
      this.wantToAgreePrivacy = this.wantToAgreeEmail = this.marketingFlagEmail = this.isCheckAll =! this.isCheckAll;
    },
    handleCheckItem (val) {
      switch (val) {
        case "wantToAgreePrivacy":
          this.wantToAgreePrivacy =! this.wantToAgreePrivacy;
          break;
        case "wantToRegisterReward":
          this.wantToRegisterReward =! this.wantToRegisterReward;
          break;
        case "wantToAgreeEmail":
          this.wantToAgreeEmail =! this.wantToAgreeEmail;
          break;
        case "marketingFlagEmail":
          this.marketingFlagEmail =! this.marketingFlagEmail;
          break;
      }
      if(!this.isTrade) {
        if(this.isRegisteredReward && !this.isAgreeEmail && this.isShowReward) {
          this.isCheckAll = this.wantToAgreePrivacy && this.wantToAgreeEmail && this.marketingFlagEmail;
        } else {
          this.isCheckAll = this.wantToAgreePrivacy && this.wantToRegisterReward && this.marketingFlagEmail;
        }
      } else {
        this.isCheckAll = this.wantToAgreePrivacy && this.wantToAgreeEmail && this.marketingFlagEmail;
      }
    }
  },
  computed: {
    sessionKey() {
      return this.$store.state.page.sessionKey;
    },
    customClassName() {
      let customClassName = { in: this.isShowModal, active: this.isShow };
      if (this.customClass && this.customClass.length > 0) {
        customClassName[this.customClass] = true;
      }
      return customClassName;
    },
    privacyLink() {
      return process.env.VUE_APP_BASE_URL + "/Rccl.UserCenter/Privacy";
    },
    userAgreementLink() {
      return process.env.VUE_APP_BASE_URL + "/content/brand/legalinfo/repeat";
    },
    rewardPrivacyLink() {
      return process.env.VUE_APP_BASE_URL + "/Rccl.UserCenter/RewardRule";
    },
    returnUrl() {
      return this.$router.currentRoute.query.returnUrl || "";
    },
    viewSource() {
      return this.$store.state.user.viewSource || '';
    }
  },
  watch: {
    isShow(newValue) {
      setTimeout(() => {
        this.isShowModal = newValue;
      }, 100);
      if (newValue) {
        this.getQrCode();
      } else {
        if (this.checkQrCodeLoginTimeout)
          clearTimeout(this.checkQrCodeLoginTimeout);
      }
    },
  },
};
</script>

<style lang="less" scoped>
/* GLOBAL STYLES
-------------------------------------------------- */
.button--purple {
  color: #fff;
  background-color: #0c1856;
}

/* Padding below the footer and lighter body text */
/* RESPONSIVE CSS
  ------------------------------------------------------------------------------------------------- */
/* common */
.login {
  display: block;
  /*background-image: url(../image/login/bg.jpg);*/
  background-size: cover;
}
#loginModal .modal-dialog {
  width: 476px;
  .caret {
    margin-left: 5px;
  }
}

#loginModal.loginPageModal {
  position: absolute;
  display: block;
  z-index: 1049;
  overflow: initial;
}

#loginModal.loginPageModal .modal-dialog {
  top: 15px !important;
  position: absolute;
  right: 270px;
}

#loginModal.loginPageModal .form--login {
  margin-top: 0px;
}

.modal.active {
  display: block;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.form--login {
  position: relative;
  width: 100%;
  margin-top: 100px;
  padding-bottom: 20px;
  border-radius: 3px;
  box-shadow: 0px 1px 50px rgba(0, 0, 0, 0.5);
}
.login_close {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  top: 11px;
}

.form--login .form--login__wrapper {
  position: relative;
  top: 0;
  left: 0;
}

.form--login .form--login__content {
  position: relative;
  top: -58px;
}

.form--login .form--login__tips {
  position: absolute;
  top: 0px;
  right: 0px;
}

.form--login .form--login__tips_tooltip {
  width: 80px;
  height: 80px;
  cursor: pointer;
  position: relative;
  z-index: 10;
}

.form--login__left,
.form--login__right {
  position: relative;
  width: 100%;
  background: #fff;
  top: 81px;
}

.form--login .form--login-bg {
  position: absolute;
  top: 0px;
}

.form--login .wechat-login-wrapper {
  text-align: center;
}

.form--login__left {
  height: 510px;
  border-right: dashed 2px #e5e5e5;
  text-align: center;
}
.left__header {
  margin: 30px 0px;
}

.left__header p {
  color: #031257;
  font-weight: 600;
  font-size: 18px;
}

.left__logo {
  margin: 42px 0px;
}
.form--login--wechatbind {
  height: 420px;
}

#loginModal .form--login__title {
  text-align: center;
  position: relative;
  top: -53px;
}

#loginModal .form--login__title .form--login__title-image {
  width: 40px;
  margin: 0 auto;
}

#loginModal .form--login__title .form--login__title-image > img{
  width: 100%;
}

#loginModal .form--login__title .form--login__title-text {
  margin-top: 10px;
  font-size: 26px;
  color: #000f56;
  margin-top: 1px;
  font-weight: bold;
}

.form--login__top {
  position: relative;
  z-index: 1;
  height: 3px;
  background: #fbc500;
  width: 376px;
}
.form--login__slash {
  text-align: center;
  display: inline-block;
  margin-top: 10px;
  margin-left: 88px;
}
.form--login__slash span {
  color: #c0c0c0;
}
.form--login__slash span:before {
  content: "";
  display: inline-block;
  width: 100px;
  height: 1px;
  background-color: #e0e0e0;
  margin: auto;
  vertical-align: middle;
  margin-right: 1em;
}
.form--login__slash span:after {
  position: relative;
  content: "";
  display: inline-block;
  width: 100px;
  height: 1px;
  background-color: #e0e0e0;
  margin: auto;
  margin-left: 1em;
  vertical-align: middle;
}
.form--login .rccl--form {
  padding: 0px 30px;
  margin: auto;
}

.form--login .rccl--form img.codeLogin {
  width: 185px;
  border: solid 1px #d6dadd;
  margin-top: 22px;
}

.form--login .wechat-login-wrapper .rccl--form p {
  font-size: 14px;
  color: #747d80;
  font-weight: 400;
  margin-top: 10px;
}

.form--login .rccl--form .callingCode {
  border-radius: 0;
  height: 45px;
  line-height: 45px;
  font-style: normal;
  width: 100px;
}

.form--login .rccl--form .callingCode .btn {
  height: 45px;
  position: relative;
  top: -1px;
  border-radius: 0px;
  width: 131px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.form--login .rccl--form .callingCode .callingcode-dropdown {
  max-height: 300px;
  overflow-y: scroll;
}

.form--login .rccl--form .phone-input-content {
  padding-left: 0px;
}

.form--login .rccl--form input {
  border-radius: 0;
  height: 45px;
  line-height: 45px;
  font-style: normal;
  float: initial;
  text-align: left;
  width: 246px;
  padding: 6px 10px;
}

.form--login .rccl--form .callingCode-content {
  width: 129px;
}

.form--login .rccl--form .veriCode-content {
  width: 248px;
}

.form--login .rccl--form .picCode-content {
  padding-top: 12px;
}

.form--login .rccl--form input.input--veriCode {
  width: 225px;
  margin-left: 0px;
}

.form--login .rccl--form input.picCode {
  width: 224px;
  margin-left: 0px;
}

.form--login .rccl--form .check--login {
  margin-top: 15px;
}
.form--login .input--login--mobile {
  margin-bottom: 15px;
}
.form--login .input--login--mobile a {
  cursor: pointer;
  &.changeCode {
    margin-left: 4px;
  }
}
.form--login .input--login--user {
  position: relative;
  margin-bottom: 15px;
}
.form--login .input--login--user a {
  font-size: 12px;
  color: blue;
}
.form--login .input--login--user .eyeIcon {
  position: absolute;
  position: absolute;
  top: 7px;
  right: 15px;
  cursor: pointer;
}

.form--login .button__sendVeri {
}

.form--login .button {
  text-align: center;
}
.form--login__button {
  width: 100%;
  border-radius: 0;
  background: #fbc500;
  color: #282b2c;
  font-size: 16px;
  line-height: 45px;
  border: none;
  font-weight: bold;
  margin: 10px 0px 10px;
  padding: 0;
}

.form--login .get_code {
  width: 153px;
  border-radius: 0;
  height: 45px;
  line-height: 45px;
  padding: 0;
  color: #54a3de;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #54a3de;
  background: transparent;
}

.form--login__Rlink {
  display: inline-block;
  float: right;
}
.form--login__link {
  text-align: center;
  font-size: 16px;
  margin-top: 15px;
}
.form--login__link--pwd {
  float: left;
}
.form--login__link--new {
  float: right;
}

.tab--login {
  width: 100%;
  height: 65px;
  padding: 0px 15px;
}

.tab__triEle {
  width: 100%;
  float: left;
  margin: 25px 0px;
  text-align: center;
  border-bottom: 1px #e5e5e5 solid;
}
.tab__triEle p {
  color: #666666;
  font-size: 18px;
}
.tab__triEle p:hover {
  cursor: pointer;
}

.tab__triEle.active {
  border-bottom: 2px #fcc400 solid;
}
.tab__triEle.active p {
  font-weight: 600;
  color: #031257;
}
.tab__douEle {
  width: 50%;
  float: left;
  margin: 25px 0px;
  text-align: center;
  border-bottom: 1px #e5e5e5 solid;
}
.tab__douEle p {
  color: #666666;
  font-size: 18px;
}
.tab__douEle p:hover {
  cursor: pointer;
}

.tab__douEle.active {
  border-bottom: 2px #fcc400 solid;
}
.tab__douEle.active p {
  font-weight: 600;
  color: #031257;
}
.mobile_login {
  margin-top: 20px;
}

.user_login {
  margin-top: 50px;
}

.weixin_login {
  margin-top: 23px;
  text-align: center;
}
.weixin_login .weixin__login__txt {
  margin: 0px;
}
.weixin_login #QRcode_container {
  width: 100%;
  text-align: center;
}

#QRcode_container img {
  width: 60%;
}
.weixin_login .form--login__link {
  margin: 0 auto;
}

.impowerBox .qrcode {
  width: 180px;
}

.impowerBox .title {
  display: none;
}

.impowerBox .info {
  width: 200px;
}

.status_icon {
  display: none;
}

.impowerBox .status {
  text-align: center;
}

.checkbox--img {
  display: inline-block;
}

.sin_container a {
  /* color: #edb000; */
}

.sin_container .isAgreePrivacy {
  margin-top: 5px;
}

.sin_container .isRegisterMember {
  margin-top: 5px;
}

.sin_container .input__top img {
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.sin_container .input__top.isAgreePushMsg img:nth-child(1) {
  display: none;
}
.sin_container .input__top.isAgreePushMsg img:nth-child(2) {
  display: inline-block;
}
.sin_container .input__top.isAgreePushMsg.active img:nth-child(1) {
  display: inline-block;
}
.sin_container .input__top.isAgreePushMsg.active img:nth-child(2) {
  display: none;
}

.sin_container .input__top.isRegisterMember img:nth-child(1) {
  display: none;
}

.sin_container .input__top.isRegisterMember img:nth-child(2) {
  display: inline-block;
}

.sin_container .input__top.isRegisterMember.active img:nth-child(1) {
  display: inline-block;
}

.sin_container .input__top.isRegisterMember.active img:nth-child(2) {
  display: none;
}

.sin_container .input__top.isAgreePrivacy img:nth-child(1) {
  display: none;
}
.sin_container .input__top.isAgreePrivacy img:nth-child(2) {
  display: inline-block;
}
.sin_container .input__top.isAgreePrivacy.active img:nth-child(1) {
  display: inline-block;
}
.sin_container .input__top.isAgreePrivacy.active img:nth-child(2) {
  display: none;
}

.sin_container span {
  vertical-align: middle;
  color: #333;
  font-size: 13px;
  margin-left: 3px;
  cursor: default;
}
.sin_container a {
  color: #54A3DE;
}
.sin_container .is-important {
  color: #F33D0F;
  font-style: normal;
}

.login-remindTxt {
  margin-top: 22px;
  font-size: 13px;
}

.login-remindTxt span {
  color: #fcc400;
}

.loginPromot {
  text-align: left;
  line-height: 1.6;
  margin-top: 0px;
  font-size: 12px;
}

/*------------- common -------------*/
/* pc
  ------------------------------------------------------------------------------------------------------- */
/*-------------pc--------------*/
/* RESPONSIVE CSS
  ------------------------------------------------------------------------------------------------- */
/* tablet landscape*/
@media screen and (min-width: 768px) and (max-width: 1200px) {
  .login {
    align-items: center;
  }

  .form--login {
    position: relative;
    right: 0px;
  }
}
/* RESPONSIVE CSS
  ------------------------------------------------------------------------------------------------- */
/* tablet portrait*/
#code,
#codeLogin {
  font-style: italic;
  font-weight: bold;
  border: 0;
  letter-spacing: 2px;
  color: blue;
}

.input--veri-div {
  /*display: none;*/
}

.checkbox--img,
.checkbox--imgLogin {
  display: inline-block;
}

/*# sourceMappingURL=login.css.map */
</style>

<style lang="less">
#loginModal .form--login__wrapper .tooltip {
  width: auto;
  height: auto;
}

#loginModal .form--login__wrapper .tooltip .arrow {
  border-left-color: #54a3de;
  top: 50% !important;
  right: -4px;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  color: transparent;
}

#loginModal .form--login__wrapper .tooltip .tooltip-inner {
  background: #54a3de;
  color: white;
  padding: 5px 10px;
  width: 100px;
}


// 滑动验证
#loginModal .form--login {
	#captcha {
		position: relative;
    margin-bottom: 15px;
		.nc_wrapper {
			width: 100%;
		}
	}
}

.login-vip {
  margin: 5px 19px 0 0;
  font-size: 13px;
}
.login-vip .vip-title {
  font-weight: bold;
  padding: 0;
  margin: 0;
}
.login-vip .vip-content {
  margin: 0;
  padding: 0;
}
.login-vip .vip-content li {
  margin-top: 3px;
}
</style>


